import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const HomeIcon = React.forwardRef((props, ref) => (
  <SvgIcon ref={ref} viewBox="0 0 20.15 20.15" {...props}>
    <path d="M19.11,5.72,11.61.47a2.73,2.73,0,0,0-3.08,0L1,5.73A2.35,2.35,0,0,0,0,7.66v10.1a2.31,2.31,0,0,0,.75,1.69,2.69,2.69,0,0,0,1.8.7H8.87V16.33a1.4,1.4,0,0,1,.5-1,1.43,1.43,0,0,1,2.35,1v3.83h5.93a2.51,2.51,0,0,0,2.5-2.4V7.64A2.44,2.44,0,0,0,19.11,5.72Zm-9,8.18a2.59,2.59,0,0,0-2.42,2.42v2.75H2.51a1.39,1.39,0,0,1-1.38-1.32V7.64a1.31,1.31,0,0,1,.57-1L9.2,1.35a1.52,1.52,0,0,1,1.73,0l7.5,5.24A1.36,1.36,0,0,1,19,7.64V17.75a1.4,1.4,0,0,1-1.42,1.33H12.85V16.32A2.57,2.57,0,0,0,10.13,13.9Z" />
  </SvgIcon>
));

export default React.memo(HomeIcon);
